import SText from "@/styles/SText";
import { AcceptStateEnum } from "@/types/purchase";
import { QuotationRequest, QuotationRequestSelectedEnum, QuotationRequestStatusEnum } from "@/types/requirement";
import { dateFormat } from "@/utils/format";
import { getSupplierName } from "@/utils/supplier";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Radio, Table, Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getQuotationPrice, numFormmater } from "@/pages/Requirement/util";
interface ItemtableProps {
  data: QuotationRequest[];
  selectedId?: string;
  onSelectChange: (id: string, productId: string) => void;
  disabled: boolean;
}

const Itemtable: FC<ItemtableProps> = ({ data, selectedId, onSelectChange, disabled }) => {
  const { t } = useTranslation();

  const getStatusLabel = (status: QuotationRequestStatusEnum) => {
    return status === QuotationRequestStatusEnum.READ ||
      status === QuotationRequestStatusEnum.UNREAD ? (
      <Tag color="#2db7f5">{t("requirement.unPriced")}</Tag>
    ) : status === QuotationRequestStatusEnum.SUBMITED ? (
      <Tag color="#87d068">{t("requirement.resolved")}</Tag>
    ) : status === QuotationRequestStatusEnum.REJECTED ? (
      <Tag color="#f50">{t("requirement.reject")}</Tag>
    ) : (
      <></>
    );
  };
  const columns: ColumnsType<QuotationRequest> = useMemo(() => {
    return [
      {
        title: t('common.select'),
        dataIndex: "id",
        render: (_, record) => (
          <Radio disabled={disabled} checked={selectedId === record.id} onChange={() => onSelectChange(record.id, record.requirementItem?.productId!)} />
        )
      },
      {
        title: t("requirement.supplier"),
        dataIndex: "supplerId",
        render: (_, record) => (
          <SText
            text={getSupplierName(record.supplier)}
            style={{ width: "100%" }}
          />
        ),
      },
      {
        title: t("requirement.supplierTime"),
        dataIndex: "mrd",
        render: (_, record) => (
          <SText
            text={
              record?.supplierTime ? dateFormat(dayjs(record.supplierTime)) : ""
            }
            style={{ width: "100%" }}
          />
        ),
      },
      {
        title: t("purchase.purPrice"),
        dataIndex: "price",
        render: (_, record) => {
          const price = getQuotationPrice(record);
          return <SText text={price === null ? "" : numFormmater(price)} style={{ width: "100%" }} />;
        },
      },
      {
        title: t("requirement.mpq"),
        dataIndex: "mpq",
        render: (_, record) => (
          <SText text={record.mpq || ""} style={{ width: "100%" }} />
        ),
      },
      {
        title: t("requirement.days"),
        dataIndex: "days",
        render: (_, record) => (
          <SText
            text={record?.days?.toString() || ""}
            style={{ width: "100%" }}
          />
        ),
      },
      {
        title: t("requirement.status"),
        dataIndex: "status",
        render: (_, record) => getStatusLabel(record.status)
      },
      {
        title: t("requirement.selected"),
        dataIndex: "selected",
        render: (_, record) => {
          if (record.selected === QuotationRequestSelectedEnum.SELECTED) return <CheckOutlined style={{ color: '#87d068' }} />
          else return <CloseOutlined style={{ color: '#f50' }} />
        }
      },
      {
        title: t("purchase.purState"),
        dataIndex: "status",
        render: (_, record) => {
          if (record.purchaseItemId) {
            return <Tag color="green">{t("purchase.generated")}</Tag>
            // if (record.purchaseItem?.order?.acceptState === null) return <Tag color="blue">{t("purchase.pend")}</Tag>
            // if (record.purchaseItem?.order?.acceptState === AcceptStateEnum.RESOLVED) return <Tag color="green">{t("purchase.acceptType")}</Tag>
            // if (record.purchaseItem?.order?.acceptState === AcceptStateEnum.REJECTED) return <Tag color="red">{t("purchase.rejectType")}</Tag>
          } else {
            return <Tag>{t('purchase.nilPur')}</Tag>
          }
        }
      },
    ];
  }, [selectedId, disabled]);
  return (
    <Table
      style={{ width: "100%" }}
      dataSource={data}
      columns={columns}
      pagination={false}
      scroll={{ x: "max-content" }}
    // onRow={data => ({
    //   onClick: () => { onSelectChange(data.id, data.requirementItem?.productId!) }
    // })}
    />
  )
};

export default Itemtable;